<template>
	<div class="detail">
		<div class="swiper-container">
		    <div class="swiper-wrapper">
		        <div class="swiper-slide"><img :src="curdata.img" alt=""></div>
		    </div>
		   <!--  <div class="swiper-pagination"></div> --><!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
		</div>
		<!-- <audio :src="curdata.aideo" controls="controls" id="audio">
		    	Your browser does not support the audio tag.
		</audio> -->
		 <div class="audio">
		    <div class="so_rs">
		        <div class="audio-btn">
		             <i @click="audioState"><img :src="imgUrl2" alt="" v-show="iconshouw==true ? true : false"><img :src="imgUrl1" alt=""  v-show="iconshouw==true?false : true"/></i>
		        </div>
		        <div class="bar" style="position: relative;z-index:2">
		            <div class="progressbar"  ref="runfatbar" @click="playMusic">
		                <div class="greenbar" ref="runbar">
		                    <span class="yuan" draggable="true"></span>
		                </div>
		            </div>
		            <span style="margin-top:-3px;position: absolute;right: 0;font-size:13px;color: #466c75;">{{cTime}}</span>
		            <span style="margin-top:-3px;position: absolute;left:-5px;font-size:13px;color: #466c75;">{{dTime}}</span>
		        </div>
		        <div>
		            <audio ref="player" :src="curdata.aideo">
		            </audio>
		        </div>
		    </div>
		 </div>
		<div class="textWarp">
			<h1>{{curdata.title}}</h1>
			<p>{{curdata.etitle}}</p>
			<div class="info">
				<span>{{curdata.time}}</span>
				<p>{{curdata.etime}}</p><br>
				<span>{{curdata.material}}</span>
				<p>{{curdata.ematerial}}</p><br>
				<span>{{curdata.dimensional}}</span>
				<p>{{curdata.edimensional}}</p><br>
				<span>{{curdata.fromN}}</span>
				<p>{{curdata.efromN}}</p>
			</div>
			<div v-html="curdata.info"></div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	export default {
		data(){
			return{
				curdata:'',
				iconshouw:true,
				play: false, // 播放暂停按钮
				imgUrl1:require('../static/imgs/icon_pause.png'),
				imgUrl2:require('../static/imgs/icon_play.png'),
				cTime: '00:00', // 已播放时间
				dTime: '00:00', // 总播放时间
				play: false, // 播放暂停按钮
				audioHttp: '', // 音频链接
				barOffleft: '', //点击距离左侧时间
				allData:[{
							id:1,
							img:require('../static/1_1.png'),
							aideo:require('../static/v1/_1_.mp3'),
							title:'赫拉雕像',
							etitle:'Marble Statue of Hera',
							time:'公元前5世纪末期',
							etime:'Last decades of the V century BC',
							material:'大理石',
							ematerial:'Marble',
							dimensional:'高56厘米；长24厘米；厚24厘米；重64000克',
							edimensional:'Height 56cm;Length	24cm; Thickness 24cm；Weight 64000g',
							fromN:'赛莱河口的赫拉神庙',
							efromN:'HERAION DI FOCE SELE',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>王座上的赫拉雕像。赫拉坐在一个高椅背、无扶手的方形宝座中，脚踩长方形基座。她内穿古希腊希顿长袍，领口在胸前垂坠成三角形褶绉；外套一件宽松长衫，右胸隐约微敞。女神面部为下颌突出的方形脸庞，头戴圆柱形高冠，长发散披于肩，唯额发编起。赫拉随意搭在腿上的右手中拿着一个希腊圆盘，左手则握着一颗石榴。</p><p>作为处于统治地位的女性形象以及家庭财富的守护者，赫拉雕像对应的是古希腊的“女性世界”。</p>'
						},{
							id:2,
							img:require('../static/1_2.png'),
                    		aideo:require('../static/v1/_2_.mp3'),
							title:'城邦会堂石碑',
							etitle:'Stele of Ekklesiasterion',
							time:'公元前 4 世纪末期',
							etime:'Last decades of the IV century BC Limestone',
							material:'石灰石',
							ematerial:'Ekklesiasterion',
							dimensional:'高 115 厘米，长 36 厘米，厚 21 厘米,重 200，000 克',
							edimensional:'H 115 cm, L 36 cm, T 21 cm,Weight 200,000 g',
							info:'<p>石碑各面均覆有白色石膏，顶端的长方体通过类似钟形圆饰的结构与石碑主体相连。碑上有两条水平凹槽，顶端平面有用来固定小型青铜像的固定夹痕，青铜像现已遗失。</p><p>石 碑 的 四 面 有 希 腊 语 撰 写 的 红字 碑 文“Statis ... ies agiove ... anare built”(?)；这段碑文是卢卡尼亚的塞特提斯·塞特提里斯为宙斯撰写的，他可能是当时城中一位受人尊敬的法官。</p>'
						},{
							id:3,
							img:require('../static/1_3.png'),
                    		aideo:require('../static/v1/_3_.mp3'),
							title:'头戴花饰的女性陶塑',
							etitle:'Terracotta Bust of Flower-Woman',
							time:'公元前 4 世纪',
							etime:'IV century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 19 厘米，长 10.5 厘米，厚 9.5 厘米重 665 克',
							edimensional:'H 19 cm, L 10.5 cm, T 9.5 cm Weight 665 g',
							fromN:'赛莱河口的赫拉神庙',
							efromN:'Heraion Di Foce Sele',
							info:'<p>头戴花饰的女性半身陶制胸像。胸像小巧，外部覆盖的泛白陶泥浆改变了陶土的颜色；略粗糙的表面呈现出零散的黑色痕迹可能是焚香造成的。</p><p>这位女性有椭圆形的长脸，三角形额头，杏眼，眼窝深陷，鼻子圆润而挺 拔 。她的脖子上戴着一条项链，头发披散到双肩。优雅而复杂的冠状头饰构成发式的一部分，并固定住头纱。头纱覆盖整个头部，披散下来，露出女子的脸部和肩部。她头顶花饰的茎部和花萼较大，顶部突出的花冠为五瓣，花瓣中央有凹槽。</p>'
						},{
							id:4,
							img:require('../static/1_4.png'),
                    		aideo:require('../static/v1/_4_.mp3'),
							title:'日晷',
							etitle:'Marble Sundial',
							time:'罗马时代',
							etime:'Roman Period',
							material:'大理石',
							ematerial:'Marble',
							dimensional:'高 51 厘米，长 49 厘米，厚 30 厘米重 85，000 克',
							edimensional:'H 51 cm, L 49 cm, T 30 cm Weight 85,000 g',
							fromN:'南部圣所',
							efromN:'Santuario Meridionale',
							info:'<p>这是帕埃斯图姆出土的唯一一件日晷，属于罗马制式。日晷是利用太阳投射的影子来测定时刻的装置。它的残损令人感到极为痛心。日晷为球面型，七条小时线尚存，其中一条残损严重；其上标出至日线和赤道线，对于在一年中不同的时刻读取时间十分必要。刻度盘上小时之间的空间以衣褶的形式呈现；下方的球状构件或许代表地球。日晷两侧原有两个大型动物装饰，用于放置晷针的部分已经遗失。</p>'
						},{
							id:5,
							img:require('../static/1_5.png'),
                    		aideo:require('../static/v1/_5_.mp3'),
							title:'狮头造型滴水槽',
							etitle:'Dripstone with Lion"s Head',
							time:'公元前 6 世纪末期',
							etime:'Last decades of the VI century BC Sandstone',
							material:'砂岩',
							//ematerial:'Marble',
							dimensional:'高 41 厘米，长 72 厘米，厚 39 厘米重 60，000 克（每件）',
							edimensional:'H 41 cm, L 72 cm, T 39 cm Weight 60,000 g (each)',
							fromN:'北部圣所',
							efromN:'Santuario Settentrionale',
							info:'<p>这组狮头造型滴水槽上的狮头鬃毛浓密，张嘴吐舌。滴水槽上还雕刻有一些其他装饰纹样。水滴槽由多个并排的元素组成。</p>'
						},{
							id:6,
							img:require('../static/1_6.png'),
                    		aideo:require('../static/v1/_6_.mp3'),
							title:'蛇发女妖瓦檐饰',
							etitle:'Antefix with Gorgon"s Head',
							time:'公元前 6 世纪',
							etime:'VI century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 16 厘米，长 20 厘米，厚 20 厘米重 2，420 克',
							edimensional:'H 16 cm, L 20 cm, T 20 cm Weight 2,420 g',
							fromN:'南部圣所',
							efromN:'Santuario Meridionale',
							info:'<p>陶制瓦檐饰，蛇发女妖。蛇发女妖圆脸，两颊丰满，杏眼圆睁。她的前额有四排蜗壳式的卷发，两侧为游蛇。女妖咧嘴龇牙，舌头吐出，下颌外突。</p>'
						},{
							id:7,
							img:require('../static/1_7.jpg'),
                    		aideo:require('../static/v1/_7_.mp3'),
							title:'持圆形盾牌的雅典娜雕像',
							etitle:'Fictile Figurine of Athena with a Rounded Shield',
							time:'公元前4世纪',
							etime:'IV century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 21.5 厘米，长 9.4 厘米，厚 7.5 厘米重 395 克',
							edimensional:'H 21.5 cm, L 9.4 cm, T 7.5 cm Weight 395 g',
							fromN:'北部圣所 - 刻瑞斯神庙',
							efromN:'Santuario Settentrionale - Tempio Di Cerere',
							info:'<p>尺寸较小的红陶制雅典娜雕像。雅典娜身着希顿长袍，系腰带。她头戴战盔，左手把扶着一枚靠在地上的圆形盾牌；右臂叉腰，右腿前屈。</p>'
						},{
							id:8,
							img:require('../static/2_1.png'),
                    		aideo:require('../static/v2/1.mp3'),
							title:'红绘风格基利克斯双耳陶杯',
							etitle:'Red-figure Kylix (drinking cup)',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							dimensional:'高6厘米；直径26.5厘米重300克',
							edimensional:'Height 6cm ; Diameter 26.5cm',
							fromN:'安德廖洛8A号墓',
							efromN:'Weight 300g ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格基利克斯双耳陶杯，出土于安德廖洛8A号墓。杯身中央绘有一个面朝左侧的酒神的女祭司，她裸身于两棵月桂树之间，手中托着物品。</p>'
						},{
							id:9,
							img:require('../static/2_2.png'),
                    		aideo:require('../static/v2/2.mp3'),
							title:'红绘风格双耳旋钮盖豆',
							etitle:'Red-figure Lekane (covered bowl)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高17厘米；直径24厘米重975克',
							edimensional:'Height 17cm; Diameter 24cm Weight 975g',
							fromN:'安德廖洛57A号墓',
							efromN:'57AArchaeological Park of Paestum',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格双耳旋钮盖豆。盖豆的边缘有黑漆描绘的竖线图案，带有旋钮的盖子上装饰有两片棕叶和两朵玫瑰花。盖豆肩部描绘了一个赤裸的男性形象，他右手托一个圆盘，左手持酒神杖。另一面绘有一只天鹅。</p>'
						},{
							id:10,
							img:require('../static/2_3.png'),
                    		aideo:require('../static/v2/3.mp3'),
							title:'红绘风格细颈圆腹油瓶',
							etitle:'Red-figure Lekythes (oil flask)',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高16.5厘米；直径9厘米重235克',
							edimensional:'Height 16.5cm ; Diameter 9cm Weight 235g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>红绘风格意大利细颈圆腹油瓶， 主要绘有一个面朝左侧的女性头像。</p>'
						},{
							id:11,
							img:require('../static/2_4.png'),
                    		aideo:require('../static/v2/4.mp3'),
							title:'婚礼花瓶',
							etitle:'Lebes Gamikòs (jar associated with weddings)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高45.5厘米；直径13.5厘米重1170克',
							edimensional:'Height 45.5cm; Diameter 13.5cm Weight 1170g',
							fromN:'安德廖洛57A号墓',
							efromN:'CORREDO ANDRIUOLO T. 57A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格婚礼花瓶，瓶身彩绘自下而上依次为：装饰元素。瓶腹的彩绘一面为一个身穿长袍侧立的女性形象，她右手握着一面镜子，左手托着几枚圆球，一名手握着王冠的裸体男性站在她的面前；另一面为一个持一篮鸡蛋的半裸女子坐像。人物上方带有一条蛋形图案排列的装饰，下方是海浪纹饰。花瓶肩部是翻转的棕榈叶饰和黑绘纹饰。两侧的环状手柄带有松果装饰。</p><p>婚礼花瓶的盖子和盖豆的形制相似：两面分别有一个面朝左侧的女性头像；边缘带有波浪纹饰。环状手柄上方有一个类似盖豆的结构，盖子绘有辐射状的棕榈叶纹饰，边缘也绘有相同的纹饰。花瓶的最上方连接着一个小花瓶，两侧都有女性头部侧像。</p>'
						},{
							id:12,
							img:require('../static/2_5.png'),
                    		aideo:require('../static/v2/5.mp3'),
							title:'北壁 - 决斗和哭泣者',
							etitle:'North Slab - Duel and Crying People',
							time:'约公元前340年',
							etime:'340 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高95厘米；长227厘米；厚13厘米重617000克',
							edimensional:'Height 95cm ; Length 227cm; Thickness 13cm',
							fromN:'安德廖洛58号墓',
							efromN:'Weight 617000g ANDRIUOLO T. 58',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这个决斗和哭泣的场景，被绘于一个双坡顶墓室的北墙上。墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。墙壁上的斯芬克斯面朝右侧，利爪几乎要抓住它前方的战士。战士身着白色衣服，衣服边缘的装饰为红色；他左手抓着两杆矛，右手握着一根头朝下的矛。战士黑髯黑发，头戴红羽黄盔，右腿后蹬，左腿前弯。他的身体被一根长矛刺穿，膝盖也险些为矛所伤。他的对手穿着白色衣服，系同色腰带，衣服两侧带有红色装饰，底襟有黑色波浪纹饰。他的头盔的样式和对手的相似。他的左臂向前伸，举着一个圆形盾牌，盾牌中心为红色，中心周围为白色，最外圈为带黑点的黄色边缘。他的右侧为一个黑髯黑发持黑笛的吹奏者。吹笛人身穿红色长袍，斜披白色披风，露出右肩，脚穿黄色鞋子。吹笛人的对面站着一个双手交叉在胸前的女人。女子深色长发披肩，戴红色项链，身着白色长裙和红色罩袍。画面右侧边缘侧身站立的女子，左手扶额，右手置于胸前，穿着和女伴相似的黄色长袍。 </p>'
						},{
							id:13,
							img:require('../static/2_6.png'),
                    		aideo:require('../static/v2/6.mp3'),
							title:'青铜头盔',
							etitle:'Bronze Helmet',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'青铜',
							ematerial:'Bronze',
							dimensional:'高35厘米；长29.5厘米；宽26.5厘米;重750克',
							edimensional:'Height 35cm ; Length 29.5cm; Thickness 26.5cm;Weight 750g',
							fromN:'富谢洛2号墓',
							efromN:'FUSCILLO T. 2',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>锻造而成的青铜头盔，由具有延展性的青铜带组成。头盔正面饰有压花纹，背面为波浪纹，顶部有翅形装饰。</p>'
						},{
							id:14,
							img:require('../static/2_7.png'),
                    		aideo:require('../static/v2/7.mp3'),
							title:'红绘风格双耳旋钮盖豆',
							etitle:'Red-figure Lekane (covered bowl)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高17厘米；直径24厘米重975克',
							edimensional:'Height 17cm; Diameter 24cm Weight 975g',
							fromN:'安德廖洛57A号墓',
							efromN:'CORREDO ANDRIUOLO T.57AArchaeological Park of Paestum',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格双耳旋钮盖豆。盖豆的边缘有黑漆描绘的竖线图案，带有旋钮的盖子上装饰有两片棕叶和两朵玫瑰花。盖豆肩部描绘了一个赤裸的男性形象，他右手托一个圆盘，左手持酒神杖。另一面绘有一只天鹅。</p>'
						},{
							id:15,
							img:require('../static/2_10.png'),
                    		aideo:require('../static/v2/8.mp3'),
							title:'战士',
							etitle:'Warrior',
							time:'公元前330年',
							etime:'330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高148厘米；长90厘米；厚12厘米重300000克',
							edimensional:'H 148 cm，L 90 cm，T 12 cm Weight 300000 g',
							fromN:'安德廖洛114号，西壁',
							efromN:'West Slab,Andriuolo',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>安德廖洛墓114号墓的西墙：战士场景。</p><p>墓墙上描绘了一名手持马缰，面朝左侧的战士形象。战马通体为黄色，装备着黑的马具。战士头戴饰有红羽黑翎的头盔，身着白色短袍，腰间系黄色腰带，外披披风；足蹬黑的鞋子，着黄色护胫甲。他手中握着扛在肩上的长矛。画面两侧各有一根爱奥尼亚柱，将人物框于其中。</p>'
						},{
							id:16,
							img:require('../static/2_9.png'),
                    		aideo:require('../static/v2/9.mp3'),
							title:'南壁 - 葬礼队伍',
							etitle:'South slab - Funeral Procession',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高90厘米；长150厘米；厚13厘米重386000克',
							edimensional:'Height 90cm ; Length 150cm; Thickness 13cm Weight 386000g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这是一个双坡顶墓室的南墙（墓室较长的一边），墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。画面主体为三个面朝左侧的女性形象：左起第一个 女子黑色短发，赤足，穿着白色无袖长裙，手扶着顶在头上的红黄相间的桌子。桌上面摆着祭品，祭品中央是一个黑色细颈双耳瓶，双耳上缠绕着红色丝带，瓶子两旁摆放着鸡蛋和石榴。她身后跟随的两个女子都穿着黑色鞋子，其中一个黑色长发，身着黄色无袖长裙；另一个黑发女子披着红色头巾，也身着黄裙。墓墙主体画面的两侧有红色彩绘，右侧为涡形纹饰、棕榈叶饰和一颗石榴，左侧也有一颗石榴。上方有一条红色饰带和垂花饰。</p>'
						},{
							id:17,
							img:require('../static/2_8.png'),
                    		aideo:require('../static/v2/8.mp3'),
							title:'东壁 - 通往阴间之旅',
							etitle:'East Slab - Journey to the Underworld',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高134厘米；长91厘米；厚10厘米 重225000克',
							edimensional:'Height 134cm ; Length 91cm; Thickness 10cm Weight 225000g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>通往阴间之旅的场景被绘于一个双坡顶墓室的东墙上，墓墙为石灰岩。画面中，身穿白色短衣、足蹬黑靴的长发 年轻男子，拉着由黄色皮带牵引的小车，小车上坐着的孩子也穿着类似的衣服。人物周围有花饰和下垂的丝带。墓墙尖顶的中央有一个由十一片红黑交替 的叶片组成的棕榈叶饰，棕榈叶片延伸出两条水平的枝杈，并结出两颗石榴。棕榈叶饰下方的白色饰带上有一根朝向左侧的树枝。</p>'
						},{
							id:18,
							img:require('../static/3_1.png'),
                    		aideo:require('../static/v3/1.mp3'),
							title:'东壁 - 战士归来',
							etitle:'East Slab - Return of the Warrior',
							time:'公元前370-公元前360年',
							etime:'370/360 BC..',
							dimensional:'高139厘米；长103厘米；厚25厘米重685000克',
							edimensional:'Height 139cm ; Length 103cm; Thickness 25cm Weight 685000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T.64 LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>画面中面朝右侧站立的女性人物，穿着带有红色饰边和波浪纹饰的白色长裙，黑色鞋子，头上裹着由一个白色冠饰固定的黄色头纱。女子左手提着一只弧状把手水壶，右手向前递出一只双耳大饮杯，两个器皿均为黑色。女子的面前是一个面向左侧的骑士，骑着配白色鞍鞯的红马，身着红边白色短上衣，佩戴饰有两根白色羽毛的黄色头盔；他右手握着缰绳，左手持两根长矛，长矛搭在肩上，挂着一个锥形盾牌。</p><p>壁画上的其他彩绘装饰纹样（墓墙装饰系统）：三角墙的斜边上饰有白色线条、红色线条；红色线条中框有一个花环，花环圈出一颗石榴，两侧各有一根树枝；人物上方的红色线条勾勒出部分三角墙。</p>'
						},{
							id:19,
							img:require('../static/3_2.png'),
                    		aideo:require('../static/v3/2.mp3'),
							title:'南壁 - 拳击和决斗',
							etitle:'South Slab - Boxing and Duel',
							time:'公元前370-公元前360年',
							etime:'370/360 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高96厘米；长214厘米；厚25厘米重1130000克',
							edimensional:'Height 96cm ; Length 214cm; Thickness 25cm Weight 113000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>覆有彩绘灰泥壁的石灰岩墓墙上，展现了拳击和决斗的场景。画面上有两个赤裸相向的拳击手。左侧的拳击手仅可见其右脚和右臂；右侧拳击手黑髯黑发，左腿前屈，右腿后蹬，左臂弯曲，攥拳于胸前，右臂向前击出。一棵非常低矮的小树苗将拳击手与身后的吹笛者分隔。画面中央一根大型爱奥尼亚式柱子将拳击场景与决斗场景区分开来。决斗场景位于两棵树苗之间。</p>'
						},{
							id:20,
							img:require('../static/3_3.png'),
                    		aideo:require('../static/v3/3.mp3'),
							title:'北壁 - 战车比赛',
							etitle:'North Slab - Chariot Racing',
							time:'公元前370-公元前360年',
							etime:' 370/360 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高96厘米；长 217厘米；厚18厘米 重825000克',
							edimensional:'Height 96cm ; Length 217cm; Thickness 18cm Weight 825000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓墙由石灰岩构成，覆有灰泥壁，是拉盖多墓地中一座带有双坡顶的墓室的北墙。墓墙上的彩绘描绘了两辆向左行驶的战车，两车之间有一根装饰有红色丝带的爱奥尼亚式柱子。牵引第一辆战车的是前景中有着黄鬃的红马和后景中的黄马，两匹马都低头前行，战车的车体几乎不可见。驾车人也只是被简单勾画：第一辆战车由戴着白色尖帽、身着带红色衣襟白色长袍的男子驾驭，他黑髯黑发，左手握缰绳，右手持马鞭；第二辆战车由一匹黄马和一匹黑马牵引，两匹马的鼻子都为白色，同样低头前行。每辆战车的马匹上方都悬挂着垂花饰。墓墙右侧以一棵小树苗作结。</p><p>墓墙上还绘有白色、红色线条，以及带有树枝装饰的白色饰带。人物所在区域底色为白色，墓墙底部的底色是红色。</p>'
						},{
							id:21,
							img:require('../static/3_4.png'),
                    		aideo:require('../static/v3/4.mp3'),
							title:'西壁 - 猎鹿',
							etitle:'West Slab - Deer Hunting',
							time:'公元前370-公元前360年',
							etime:'370/360 BC.',
							dimensional:'高139厘米；长100厘米；厚19厘米重500000克',
							edimensional:'Height 139cm ; Length 100cm; Thickness 19cm Weight 500000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓室西墙由覆有灰泥壁和彩绘层的石灰岩构成，它来自于一间双坡顶墓室。墙上的彩绘描绘了猎鹿的场景。</p><p>画面中的一头黄鹿奔向左侧，一条灰色猎犬跃上了它的脊背，正准备咬它的颈部。一名猎人紧随其后，左腿向前和右腿在后，左手竖直地拿着矛，靠在胸前，右手弯曲并微微前伸，搭一件红边白外套。场景的右侧是一棵小树苗。</p>'
						},{
							id:22,
							img:require('../static/3_5.png'),
                    		aideo:require('../static/v3/5.mp3'),
							title:'南壁 - 四马双轮战车',
							etitle:'South Slab - Quadriga',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高66厘米；长151厘米；厚19厘米重417000克',
							edimensional:'Height 66cm ; Length 151cm; Thickness 19cm Weight 417000g',
							fromN:'安德廖洛48号墓',
							efromN:'ANDRIUOLO T.48',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这个战车比赛的场景被绘于一个双坡顶墓室的南墙上，墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。</p><p>画面中的战车由两匹红鬃黑白花马和两匹黑鬃白马拉动，向左奔跑的四匹马通过透视技法和不同的颜色呈现。驾驶战车者身着红、白、黑竖条纹的上衣，双手各持两条缰绳。双轮战车的透视在第一匹马的位置。</p><p>其他的彩绘图式有：一颗位于墓墙左侧、第四匹马前方的石榴；右侧边缘处有一条竖直的涡形装饰，末端也有一颗石榴。</p>'
						},{
							id:23,
							img:require('../static/3_6.png'),
                    		aideo:require('../static/v3/6.mp3'),
							title:'西壁 - 狩猎野猪',
							etitle:'West Slab - Wild Boar Hunting',
							time:'公元前375-公元前350年',
							etime:'375/350 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高94厘米； 长92厘米； 厚9厘米 重175000克',
							edimensional:'Height 94cm ; Length 92cm; Thickness 9cm Weight 175000g',
							fromN:'安德廖洛6号墓',
							efromN:'ANDRIUOLOT. 6',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面石灰岩墓墙来自于安德廖洛墓的一座箱型石墓。墓墙描绘了一个猎人的形象。猎人身体朝向观者，头转向右侧。他留着黑色短发，佩戴着黑色饰发巾，身着浅色短罩衣，腰间系着一条黑边腰带，脚蹬带有红色装饰的黑靴；他的右手后举，准备投掷一根黑色长矛，左臂披着一件黑边绿衣。猎人的对面是一头被长矛刺伤的野猪，白色的猎犬在撕咬野猪的后背；画面中央的一条黑色猎犬正准备袭击野猪，而墓墙最右侧还能看见另一条准备扑咬野猪后背的白犬的一部分。野猪全身有三道猎狗和长矛造成的伤口，鲜血淋漓。野猪身后的背景中有一棵彩绘小树，黑犬背后也依稀可见另一棵小树。地面用波浪线呈现，最初的色彩可能是绿色。</p><p>壁画上的其他彩绘装饰纹样有（墓墙装饰系统）：红色线条与红色树枝，最初可能是绿色的心形叶片，黑色点状花朵，以及黑色线条。墓墙最底部有另一条黑色线条痕迹。<p>'
						},{
							id:24,
							img:require('../static/3_7.png'),
                    		aideo:require('../static/v3/7.mp3'),
							title:'北壁 - 器物和植物纹饰',
							etitle:'North Slab - Objects and Plant Motifs',
							time:'公元前375-公元前350年',
							etime:'375/350 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高100厘米； 长217厘米； 厚16厘米 重770000克',
							edimensional:'Height 100cm ; Length 217cm; Thickness 16cm Weight 770000g',
							fromN:'安德廖洛6号墓',
							efromN:'ANDRIUOLO T. 6',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓墙上的彩绘描绘了不同的物品和植物纹饰：两只红底的黑色基利克斯杯被“钉”在墓墙上方；在这两只基利克斯杯之间，可以看到一条丝带的痕迹。</p><p>画面下方有一个双柄大口酒坛、一个弧状把手水壶和一个陶杯。这些容器的右侧是三条悬挂的丝带，两边的为红色，中间的为蓝色。壁画上的其他装饰纹样（墓墙装饰系统）由红色线条、有绿色心形叶片和黑色花朵的红色树枝，以及黑色线条构成。另一黑色线条位于墓墙下方。</p>'
						},{
							id:25,
							img:require('../static/3_8.png'),
                    		aideo:require('../static/v3/8.mp3'),
							title:'红绘风格大口双耳高脚酒坛',
							etitle:'Red-figure Calyx-krater (bowl for mixing wine and water)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高40.5厘米； 直径37.3厘米 重4465克',
							edimensional:'Height 40.5cm ; Diameter 37.3cm Weight 4465g',
							fromN:'安德廖洛20A号墓',
							efromN:'ANDRIUOLO T. 20 A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格基利克斯双耳陶杯，出土于安德廖洛8A号墓。杯身中央绘有一个面朝左侧的酒神的女祭司，她裸身于两棵月桂树之间，手中托着物品。</p>'
						}]

			}
		},
		mounted(){

			var code=this.$route.query.id-1;
			if (this.allData[code]) {
				this.curdata=this.allData[code];
				//console.log(this.curdata,123)
			}
			var mySwiper = new Swiper('.swiper-container',{
				pagination: {
				    el: '.swiper-pagination',
				},
				observer:true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents:true,//修改swiper的父元素时，自动初始化swiper
			})

			//音频播放处理
			const music = this.$refs.player  // 音频所在对象
			const musicBar = this.$refs.runbar  // 颜色进度条所在对象
			const musicWidth = this.$refs.runfatbar.offsetWidth // 底部进度条总宽
			// 获得音频加载完成可播放时的处理
			music.addEventListener('canplay', (res) => {
			    setTimeout(()=>{ 
			    	const musicTime = music.duration // 获得音频时长
			    	//console.log(res)
			    	const branch = Math.floor(musicTime / 60) // 计算音频分钟
			    	const second = Math.ceil(musicTime % 60) // 计算音频秒
			    	if (branch < 10 && second < 10) { // 四种情况判断音频总时间
			    	    this.dTime = `0${branch}:0${second}`
			    	} else if (branch < 10) {
			    	    this.dTime = `0${branch}:${second}`
			    	} else if (second < 10) {
			    	    this.dTime = `${branch}:0${second}`
			    	} else {
			    	    this.dTime = `${branch}:${second}`
			    	}
			    },300);
			})

			// 获得音频正在播放时的处理
			music.addEventListener('timeupdate', () => {
			    const musicTime = music.duration // 获得音频时长
			    const stopTime = music.currentTime // 获得已播放的音频时长
			    musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
			    const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
			    const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
			    if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
			        this.cTime = `0${branch}:0${second}`
			    } else if (branch < 10) {
			        this.cTime = `0${branch}:${second}`
			    } else if (second < 10) {
			        this.cTime = `${branch}:0${second}`
			    } else {
			        this.cTime = `${branch}:${second}`
			    }
			})
			musicBar.addEventListener('touchmove', (event) => {
			     const events = event.targetTouches[0].pageX-this.$refs.runfatbar.offsetLeft // 获得触摸拖动的距离
			     if(events <= musicWidth){
			         musicBar.style.width = `${(events / musicWidth) * 100}%` // 计算进度条所在比例宽度
			     }else{
			         musicBar.style.width = '100%'
			     }
			     music.pause() // 触摸拖动时停止播放
			})
			 // 监听颜色进度条是否触摸拖动结束
			 musicBar.addEventListener('touchend', () => {
			     const touwidth = (musicBar.offsetWidth / musicWidth) // 计算进度条所在比例
			     //console.log(touwidth)
			     music.currentTime = music.duration * touwidth // 通过所在比例赋值给音频应在的播放时间
			     music.play() // 根据播放时间开始播放
			     this.play = true // 更改播放暂停按钮为播放
			})
		},
		methods:{
			goback(){
				this.$router.go(-1)
			},
			//点击播放暂停按钮时间
			audioState () {
			   this.iconshouw=!this.iconshouw;
			    this.play = !this.play;// 更改播放暂停按钮状态
			    const music = this.$refs.player // 音频所在对象
			    if (this.play) {
			        music.play() // 播放音乐
			    } else {
			        music.pause() // 暂停音乐
			    }
			},
			//点击进度条事件
			playMusic (e) {
			    const music = this.$refs.player // 音频所在对象
			    const barWidth = (e.pageX-this.$refs.runfatbar.offsetLeft)/ this.$refs.runfatbar.offsetWidth // 计算点击位置相对父元素总宽的比例
			    this.$refs.runbar.style.width = `${barWidth * 100}%` // 进度条应所在的比例总宽
			    music.currentTime = music.duration * barWidth // 计算点击时应播放所在的时间
			    music.play() // 播放音频
			    this.play = true // 更改播放暂停按钮为播放
			}
		}
	}
</script>
<style>
	.swiper-pagination-bullet-active {
	    opacity: 1;
	    background: #ebc37d;
	}
</style>
<style scoped>
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
		z-index: 30;
	}
	.swiper-container{
		width: 90%;
		height:3rem;
		box-shadow: 0px 1px 15px #ededed;
		border-radius: 20px;
		margin-top:20px;
		z-index: 2;
	}
	.swiper-slide img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	#audio{
		display: block;
		margin: 0 auto;
		margin-top: .3rem;
		margin-bottom: .2rem;
	}
	.textWarp{
		width: 90%;
		margin: 0 auto;
	}
	.textWarp h1{
		font-size:26px;
		color:#466c75;
	}
	.info{
		margin-top: .15rem;
		margin-bottom: .15rem;
	}
	.info span{
		display: inline-block;
		margin-bottom: .05rem;
		font-size: 14px;
		color:#466c75;
	}
	.textWarp >>> p{
		color:#666666;
		font-size: 14px;
		line-height:30px;
		margin-bottom:.05rem;
		color:#466c75;
	}
	.audio{
		position: relative;
		overflow: hidden;
	}
	.audio:after{
		content:"";width:600px;top:-20%;height:185px;left:50%;margin-left: -300px;background:-webkit-linear-gradient(#fff, #f8f8f8);border-radius: 100%;position: absolute;z-index: 1;
	}
	.so_rs{
	   width: 100%;
	   position: relative;
		z-index: 2;
	   -webkit-box-sizing: border-box;
	   box-sizing: border-box;
	   display: -webkit-box;
	   display: -ms-flexbox;
	   display: flex;
	   padding-top: .4rem;
	}
	/*自定义进度条*/
	.bar{
	    width: 90%;
	    height:1.4rem;
	    line-height:.45rem;
	    box-sizing: border-box;
	    margin: 0 auto;
	}
	/*播放按钮*/
	.audio-btn{
	    width: 44px;
		height:44px;
	    left: 50%;
		margin-left: -22px;
		margin-top:.3rem;
		position: absolute;
		z-index: 3;
	}
	.audio-btn i img{
		width: 100%;
	}
	.icon{
	    display:block;
	    height:1.3rem;
	    width:1.3rem;
	}
	.progressbar{
	    width: 100%;
	    height: .01rem;
	    background-color: #999999;
	    border-radius: 10px;
	    position: relative;
	    font-size: 0;
	}
	.greenbar {
	    width: 0%;
	    height: .01rem;
	    border-radius: .2rem;
	    position: absolute;
	    top: 0;
	    left: 0;
	    background-color: #466c75;
	}
	.yuan {
	    display: inline-block !important;
	    padding: .05rem;
	    background-color: #466c75;
	    box-sizing: border-box;
	    border-radius: 50%;
	    position: absolute;
	    top: -.05rem;
	    right: -.05rem;
	    box-shadow: 2px 1px 5px #ccc;
	}
</style>